module.exports = __webpack_public_path__ + "static/media/importFlybook2.8fb6d32e.png";